// extracted by mini-css-extract-plugin
export default {"progress_bars_container_container":"progress-bars-2-container_progress_bars_container_container__4Y+cZ"};